import React from 'react';
import { Box } from '@opendoor/bricks/core';
import { colors } from '@opendoor/bricks/theme/eero';
import Footer from '@opendoor/bricks/deprecated/UNSAFE_layout/Footer';
import { BrokerageDisclaimer } from 'sellDirect/components/legacy/layout/BrokerageDisclaimer';
import { useQualificationContext } from 'shared/helpers/QualificationContext';
import { useOfferContext } from 'sellDirect/OfferContext';

export interface CakeFooterProps {
  renderCustomFooter?: () => React.ReactNode;
}

interface CakeFooterInternalProps extends CakeFooterProps {
  isSellDirectQualified: boolean;
  hasExpired: boolean;
}

/** TODO: Add documentation */
export const CakeFooterWithoutContext: React.FC<CakeFooterInternalProps> = ({
  renderCustomFooter,
  isSellDirectQualified,
  hasExpired,
}) => {
  return (
    <Box borderX={`1px solid ${colors.neutrals30}`} width="100%" maxWidth={['100%', '570px']}>
      <Box
        position="relative"
        backgroundColor="neutrals100"
        color="neutrals0"
        pt={8}
        pb={isSellDirectQualified ? 12 : [hasExpired ? '225px' : '160px', null, 0]}
      >
        {renderCustomFooter ? renderCustomFooter() : <BrokerageDisclaimer />}
        <Footer minimal color="neutrals0" centerAlign={false} />
      </Box>
    </Box>
  );
};

/** TODO: Add documentation */
export const CakeFooter: React.FC<CakeFooterProps> = ({ renderCustomFooter }) => {
  const { isSellDirectQualified } = useQualificationContext();
  const { offer } = useOfferContext();
  return (
    <CakeFooterWithoutContext
      isSellDirectQualified={isSellDirectQualified}
      hasExpired={offer?.isExpired ?? false}
      renderCustomFooter={renderCustomFooter}
    />
  );
};
